import { graphql, useStaticQuery } from 'gatsby';

export const useHeroImages = () => {
  const images = useStaticQuery(graphql`
    query QabHeros {
      default: file(relativePath: { eq: "hero/qab-default.jpg" }) {
        ...heroImage
      }
      rabbit: file(relativePath: { eq: "hero/qab-rabbit.jpg" }) {
        ...heroImage
      }
      dog: file(relativePath: { eq: "hero/qab-dog.jpg" }) {
        ...heroImage
      }
      cat: file(relativePath: { eq: "hero/qab-cat.jpg" }) {
        ...heroImage
      }
      equine: file(relativePath: { eq: "hero/qab-equine.jpg" }) {
        ...heroImage
      }
    }

    fragment heroImage on File {
      childImageSharp {
        gatsbyImageData(
          width: 1440
          height: 840
          layout: FULL_WIDTH
          placeholder: BLURRED
          formats: AUTO
          transformOptions: { fit: COVER, cropFocus: ATTENTION }
          quality: 90
        )
      }
    }
  `);

  return images;
};
